import { FC, memo } from "react"
import { useTranslation } from "react-i18next"
import { rarityStyle } from "@/helpers/rarity"
import styles from "./MobDropGrid.module.scss"
import { IMobDropGridProps } from "./types"

const MobDropGridComponent: FC<IMobDropGridProps> = ({ drops }) => {
  const { t } = useTranslation("inventory")

  return (
    <ul className={styles.MobDropGrid}>
      {drops.map((drop, index) => (
        <li
          key={`${drop.itemCode}:${drop.rarityCode}:${index}`}
          className={styles.MobDropGrid_tile}
          style={rarityStyle({
            rarityCode: drop.rarityCode,
            hasRarityDimension: true
          })}
        >
          {drop.iconUrl ? (
            <img
              className={styles.MobDropGrid_icon}
              src={drop.iconUrl}
              alt={t(`item.${drop.itemCode}.name`)}
              decoding="async"
            />
          ) : (
            <span className={styles.MobDropGrid_name}>
              {t(`item.${drop.itemCode}.name`)}
            </span>
          )}
          <span className={styles.MobDropGrid_quantity}>×{drop.quantity}</span>
        </li>
      ))}
    </ul>
  )
}

export const MobDropGrid = memo(MobDropGridComponent)
